module.exports = __webpack_public_path__ + "assets/585fcbfc4b4dbf8a476386bdb3148898.png";